import React from 'react';
import './StartingHoleModal.css';

const StartingHoleModal = ({ isOpen, onSelect, onClose, currentHole }) => {
  if (!isOpen) return null;

  const holes = Array.from({ length: 18 }, (_, i) => i + 1);

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content starting-hole-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Select Starting Hole</h2>
          <p>This will set the hole order for the entire group.</p>
        </div>
        <div className="hole-grid">
          {holes.map((hole) => (
            <button 
              key={hole} 
              className={`hole-button ${hole === currentHole ? 'suggested' : ''}`}
              onClick={() => onSelect(hole)}
            >
              {hole}
            </button>
          ))}
        </div>
        <div className="modal-footer">
          <button className="cancel-button" onClick={onClose}>Cancel</button>
        </div>
      </div>
    </div>
  );
};

export default StartingHoleModal;
